import { useDialogStore } from '~/stores/dialog.ts';

const defaultProps = {
  transition: { name: 'fade' },
  selfClick: true,
};

export function useModals() {
  const dialogStore = useDialogStore();

  const openModal = (name: string, props = {}) => {
    dialogStore.componentName = name;
    dialogStore.componentProps = { ...defaultProps, ...props };
    dialogStore.showDialog = true;
    if (import.meta.client) {
      document.body.classList.add('overflow-hidden');
    }
  };

  const toggleComponent = (state?: boolean) => {
    dialogStore.showDialog = typeof state === 'boolean' ? state : !dialogStore.showDialog;
    if (!dialogStore.showDialog && import.meta.client) {
      document.body.classList.remove('overflow-hidden');
    }
  };

  const closeModal = () => {
    dialogStore.componentName = null;
    dialogStore.componentProps = defaultProps;
    if (import.meta.client) {
      document.body.classList.remove('overflow-hidden');
    }
  };

  return { closeModal, openModal, toggleComponent };
}
